export type RouteLocaleType =
  | 'en'
  | 'es'
  | 'fr'
  | 'id'
  | 'ru'
  | 'vi'
  | 'zh'
  | 'da'
  | 'es-es'
  | 'fr-fr'
  | 'it'
  | 'pl'
  | 'pt'
  | 'ro'
  | 'de'
  | 'hr'
  | 'nl'
  | 'el'
  | 'no'
  | 'se'
  | 'en-es'
  | 'en-fr'
  | 'en-de'
  | 'en-it'
  | 'en-nl'
  | 'en-no'
  | 'us'
  | 'es-us'
  | 'sg'
  | 'uk'
  | 'en-br'
  | 'pt-br'
  | 'fr-ca'
  | 'ca'
  | 'en-kr'
  | 'kr'
  | 'en-ae'
  | 'ae'
  | 'au'
  | 'eea'

type RegionLocaleMap = {
  locale: string
}

/**
 * same map from https://github.com/cdc-internal/aurora-site/blob/feature/bm-3479-url-restructure-old-navbar/src/configs/routes.ts
 * related doc: https://docs.google.com/spreadsheets/d/1BIF8yo7plzDT03NeyGbSTD6TcLkN3fz4eCGzxyYB2kE/edit?hl=en&gid=1370183523#gid=1370183523
 */
export const routeLocaleToStandardLocaleMap: Record<RouteLocaleType, RegionLocaleMap> = {
  en: {
    locale: 'en',
  },
  es: {
    locale: 'es',
  },
  fr: {
    locale: 'fr',
  },
  id: {
    locale: 'id',
  },
  ru: {
    locale: 'ru',
  },
  vi: {
    locale: 'vi',
  },
  zh: {
    locale: 'zh-TW',
  },
  da: {
    locale: 'da',
  },
  'es-es': {
    locale: 'es',
  },
  'fr-fr': {
    locale: 'fr',
  },
  it: {
    locale: 'it',
  },
  pl: {
    locale: 'pl',
  },
  pt: {
    locale: 'pt',
  },
  ro: {
    locale: 'ro',
  },
  de: {
    locale: 'de',
  },
  hr: {
    locale: 'hr',
  },
  nl: {
    locale: 'nl',
  },
  el: {
    locale: 'el',
  },
  no: {
    locale: 'no',
  },
  se: {
    locale: 'sv',
  },
  'en-es': {
    locale: 'en',
  },
  'en-fr': {
    locale: 'en',
  },
  'en-de': {
    locale: 'en',
  },
  'en-it': {
    locale: 'en',
  },
  'en-nl': {
    locale: 'en',
  },
  'en-no': {
    locale: 'en',
  },
  us: {
    locale: 'en-US',
  },
  'es-us': {
    locale: 'es',
  },
  sg: {
    locale: 'en',
  },
  uk: {
    locale: 'en',
  },
  'en-br': {
    locale: 'en',
  },
  'pt-br': {
    locale: 'pt-BR',
  },
  au: {
    locale: 'en',
  },
  'fr-ca': {
    locale: 'fr-CA',
  },
  ca: {
    locale: 'en',
  },
  'en-kr': {
    locale: 'en',
  },
  kr: {
    locale: 'ko',
  },
  'en-ae': {
    locale: 'en',
  },
  ae: {
    locale: 'ar',
  },
  eea: {
    locale: 'en',
  },
}

/**
 * @docs https://docs.google.com/spreadsheets/d/1BIF8yo7plzDT03NeyGbSTD6TcLkN3fz4eCGzxyYB2kE/edit?hl=en&gid=1370183523#gid=1370183523
 * length: 41
 */
export const routeLocales: RouteLocaleType[] = Object.keys(
  routeLocaleToStandardLocaleMap,
) as RouteLocaleType[]

/**
 * @link https://docs.google.com/spreadsheets/d/1BIF8yo7plzDT03NeyGbSTD6TcLkN3fz4eCGzxyYB2kE/edit?gid=1210184736#gid=1210184736
 */
export const hrefLangToRoutePairs = [
  { lang: 'en', route: 'en' },
  { lang: 'es', route: 'es' },
  { lang: 'es-US', route: 'es-us' },
  { lang: 'fr', route: 'fr' },
  { lang: 'zh-Hant', route: 'zh' },
  { lang: 'id', route: 'id' },
  { lang: 'ru', route: 'ru' },
  { lang: 'vi', route: 'vi' },
  { lang: 'en-US', route: 'us' },
  { lang: 'en-GB', route: 'uk' },
  { lang: 'en-CA', route: 'ca' },
  { lang: 'fr-CA', route: 'fr-ca' },
  { lang: 'en-AU', route: 'au' },
  { lang: 'en-SG', route: 'sg' },
  { lang: 'ar-AE', route: 'ae' },
  { lang: 'en-AE', route: 'en-ae' },
  { lang: 'pt-BR', route: 'pt-br' },
  { lang: 'en-BR', route: 'en-br' },
  { lang: 'ko-KR', route: 'kr' },
  { lang: 'en-KR', route: 'en-kr' },
  { lang: 'da', route: 'da' },
  { lang: 'es-ES', route: 'es-es' },
  { lang: 'en-ES', route: 'en-es' },
  { lang: 'fr-FR', route: 'fr-fr' },
  { lang: 'en-FR', route: 'en-fr' },
  { lang: 'de', route: 'de' },
  { lang: 'en-DE', route: 'en-de' },
  { lang: 'it', route: 'it' },
  { lang: 'en-IT', route: 'en-it' },
  { lang: 'pl', route: 'pl' },
  { lang: 'pt', route: 'pt' },
  { lang: 'nl', route: 'nl' },
  { lang: 'en-NL', route: 'en-nl' },
  { lang: 'sv-SE', route: 'se' },
  { lang: 'no', route: 'no' },
  { lang: 'en-NO', route: 'en-no' },
  { lang: 'el', route: 'el' },
  { lang: 'hr', route: 'hr' },
  { lang: 'ro', route: 'ro' },
  { lang: 'en-BE', route: 'eea' },
  { lang: 'en-BG', route: 'eea' },
  { lang: 'en-HR', route: 'eea' },
  { lang: 'en-CY', route: 'eea' },
  { lang: 'en-CZ', route: 'eea' },
  { lang: 'en-DK', route: 'eea' },
  { lang: 'en-EE', route: 'eea' },
  { lang: 'en-FI', route: 'eea' },
  { lang: 'en-IS', route: 'eea' },
  { lang: 'en-IE', route: 'eea' },
  { lang: 'en-LV', route: 'eea' },
  { lang: 'en-LI', route: 'eea' },
  { lang: 'en-LT', route: 'eea' },
  { lang: 'en-LU', route: 'eea' },
  { lang: 'en-MT', route: 'eea' },
  { lang: 'en-PL', route: 'eea' },
  { lang: 'en-RO', route: 'eea' },
  { lang: 'en-SK', route: 'eea' },
  { lang: 'en-SI', route: 'eea' },
  { lang: 'en-SE', route: 'eea' },
  { lang: 'x-default', route: 'en' },
]

export const unsupportedRouteLocaleMap: Record<string, string> = {}

/**
 * key: CountryCode from header
 * value: routeLocale
 */
export const forceRedirectCountryLocaleMap: Record<string, string> = {
  KR: 'kr',
  UK: 'uk',
  GB: 'uk',
  SG: 'sg',
  AT: 'de',
  BE: 'eea',
  BG: 'eea',
  HR: 'hr',
  CY: 'eea',
  CZ: 'eea',
  DK: 'eea',
  EE: 'eea',
  FI: 'eea',
  IS: 'eea',
  IE: 'eea',
  LV: 'eea',
  LI: 'eea',
  LT: 'eea',
  LU: 'eea',
  MT: 'eea',
  PL: 'pl',
  RO: 'ro',
  SK: 'eea',
  SI: 'eea',
  SE: 'eea',
  HU: 'eea',
}

export const tokenizedStocksLocales: RouteLocaleType[] = ['en']
